<template>
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses">
    <b-tab title="Forecast" class="e-card__content">
      <b-table hover outlined class="e-table e-table--filter--gray-scale" :fields="forecastTableFields" :items="forecastTableItems">
        <template slot="HEAD_forecasted" slot-scope="data">
          Forecast crowd / <b>Your</b>
        </template>
        <template slot="HEAD_accuracy" slot-scope="data">
          <p class="text-center">{{ data.label }}</p>
        </template>
        <template slot="index" slot-scope="data">
          {{ data.index + 1 }}
        </template>
        <template slot="preview" slot-scope="data">
          <div class="d-flex align-items-center">
            <div class="e-avatar size-30 mr-4">
              <img src="../../../assets/assets/bitcoin.svg">
            </div>
            <div class="d-flex flex-column">
              <b>Bitcoin</b>
              <small class="eh-secondary-text">BTC</small>
            </div>
          </div>
        </template>
        <template slot="forecasted" slot-scope="data">
          {{ data.item.crowd }} / <b>{{ data.item.your }}</b>
        </template>
        <template slot="accuracy" slot-scope="data">
          <p class="text-center">{{ data.value }}</p>
        </template>
        <template slot="actions" slot-scope="data">
          ...
        </template>
      </b-table>
    </b-tab>
    <b-tab title="Rate"></b-tab>
    <b-tab title="Portfolio"></b-tab>
  </e-card>
</template>

<script>
	import ECard from "../../elements/card/card";
  import DynamicSizeMixin from '../../../mixins/dynamicSize';

  export default {
		name: "ec-events",
    mixins: [DynamicSizeMixin],
    components: {ECard},
    data() {
		  return {
        forecastTableFields: [
          {
            key: 'index',
            label: '№'
          },
          {
            label: 'Coin',
            key: 'preview'
          },
          {
            key: 'forecasted',
          },
          {
            key: 'actual',
            label: 'Actual price',
            formatter: (value) => `${value} USD`,
          },
          {
            key: 'accuracy',
            label: 'Accuracy percentile',
            formatter: (value) => `${value}%`,
          },
          {
            key: 'actions',
            label: '',
          }
        ],
        forecastTableItems: [
          {
            crowd: 10000,
            asset: 'bitcoin',
            your: 12300,
            actual: 11300,
            accuracy: 68,
          },
          {
            crowd: 10000,
            asset: 'bitcoin',
            your: 12300,
            actual: 11300,
            accuracy: 68,
          },
          {
            crowd: 10000,
            asset: 'bitcoin',
            your: 12300,
            actual: 11300,
            accuracy: 68,
          },
        ],
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/events/events.vue